const CharacterPromptData = {
	gender: {
		MALE: 'Male',
		FEMALE: 'Female',
	},

	origin: {
		EUROPEAN: 'European',
		AFRICAN: 'African',
		ASIAN: 'Asian',
		SOUTH_ASIAN: 'South Asian',
		EAST_ASIAN: 'East Asian',
		MIDDLE_EASTERN: 'Middle Eastern',
		SOUTH_AMERICAN: 'South American',
		NORTH_AMERICAN: 'North American',
	},

	age: {
		TEENAGER: 'Teenager',
		YOUNG_ADULT: 'Young adult',
		ADULT: 'Adult',
		ELDERLY: 'Elderly',
	},

	bodytype: {
		NORMAL: 'Normal',
		SLIM: 'Slim',
		FIT: 'Fit',
		MUSCULAR: 'Muscular',
		CURVY: 'Curvy',
		CHUBBY: 'Chubby',
	},

	hairtype: {
		STRAIGHT: 'Straight',
		WAVY: 'Wavy',
		CURLY: 'Curly',
		FRIZZY: 'Frizzy',
		THICK: 'Thick',
		SILKY: 'Silky',
		COILY: 'Coily',
		BALD: 'Bald',
	},

	haircolor: {
		BLACK: 'Black',
		BLONDE: 'Blonde',
		BRUNETTE: 'Brunette',
		GRAY: 'Gray',
		WHITE: 'White',
		RED: 'Red',
		PINK: 'Pink',
		BLUE: 'Blue',
		GREEN: 'Green',
	},

	style: {
		CASUAL: 'Casual',
		STREETWEAR: 'Streetwear',
		FORMAL: 'Formal',
		TRADITIONAL: 'Traditional',
		GOTHIC: 'Gothic',
		RETRO: 'Retro',
		FANCY: 'Fancy',
		GYM: 'Gym',
		VINTAGE: 'Vintage',
		CLASSY: 'Classy',
		BOHO_CHIC: 'Boho-chic',
	},

	background: {
		CAFE: 'Cafe',
		GYM: 'Gym',
		OFFICE: 'Office',
		BUSY_STREET: 'Busy street',
		GARDEN: 'Garden',
		MOUNTAINS: 'Mountains',
	},
};

const defaultSelectedData = {
	gender: CharacterPromptData.gender.FEMALE,
	origin: CharacterPromptData.origin.SOUTH_AMERICAN,
	age: CharacterPromptData.age.YOUNG_ADULT,
	bodytype: CharacterPromptData.bodytype.MUSCULAR,
	hairtype: CharacterPromptData.hairtype.STRAIGHT,
	haircolor: CharacterPromptData.haircolor.BRUNETTE,
	style: CharacterPromptData.style.CLASSY,
	background: CharacterPromptData.background.BUSY_STREET,
};

const displayCategoryName = {
	gender: 'Gender',
	origin: 'Origin',
	age: 'Age',
	bodytype: 'Body type',
	hairtype: 'Hair type',
	haircolor: 'Hair color',
	style: 'Style',
	background: 'Background',
};

const prefixs = {
	gender: 'a',
	style: 'wearing',
};
const suffixs = {
	bodytype: 'body',
	haircolor: 'hair',
	background: 'in the background',
	style: 'clothes',
};

export { CharacterPromptData, defaultSelectedData, displayCategoryName, prefixs, suffixs };
